import React from 'react'
import '../../App.less'
import QuestionMark from "../../assets/QuestionMark.svg"
import { Tooltip } from 'antd'

const IconTooltip = ({ className, title, onClick, zIndex, overClassName, place = "right", ...props }) => {
  return (
    <Tooltip title={title} zIndex={zIndex} placement={place} color={"#fff"} overlayInnerStyle={style.containerStyle} overlayClassName={overClassName}>
      <img src={QuestionMark} onClick={onClick} style={{ marginLeft: 5, cursor: 'pointer' }} alt={''}></img>
    </Tooltip >
  )
}

const style = {
  containerStyle: {
    background: '#fff',
    padding: 5,
    fontSize: 12,
    lineHeight: "16px",
    color: '#444',
    borderRadius: 7,
    width: 150,
  }
}

export default IconTooltip